import { ArrowRight, Phone, Clock, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';

export const HeroSection = () => {
  const scrollToCalculator = () => {
    const element = document.getElementById('roi-calculator');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToCta = () => {
    const element = document.getElementById('cta-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[90vh] flex items-center grid-pattern" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="space-y-8">
            {/* Social Proof Badge */}
            <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-sm px-4 py-2 text-sm font-medium text-slate-600">
              <CheckCircle2 className="w-4 h-4 text-green-600" />
              <span>Trusted by 50+ Roofing Contractors</span>
            </div>
            
            {/* Headline */}
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 leading-[1.1]" data-testid="hero-headline">
              Stop Losing Roofing Jobs to Slow Follow-Up
            </h1>
            
            {/* Subheadline */}
            <p className="text-lg md:text-xl text-slate-600 leading-relaxed max-w-xl">
              The AI-powered booking system that answers every lead in seconds and schedules inspections 24/7. Built for roofing companies with 5–50 employees.
            </p>
            
            {/* Stats Row */}
            <div className="flex flex-wrap gap-8 py-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded bg-orange-100 flex items-center justify-center">
                  <Clock className="w-5 h-5 text-orange-600" />
                </div>
                <div>
                  <p className="font-heading text-2xl font-bold text-slate-900">5 min</p>
                  <p className="text-sm text-slate-500">Response Time Target</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded bg-green-100 flex items-center justify-center">
                  <Phone className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <p className="font-heading text-2xl font-bold text-slate-900">+30%</p>
                  <p className="text-sm text-slate-500">More Inspections Booked</p>
                </div>
              </div>
            </div>
            
            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={scrollToCalculator}
                className="bg-orange-600 hover:bg-orange-700 text-white font-semibold px-8 py-6 text-base rounded-sm active:scale-[0.98] transition-transform"
                data-testid="hero-cta-calculator"
              >
                Calculate Your Lost Revenue
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button 
                variant="outline"
                onClick={scrollToCta}
                className="border-slate-300 text-slate-700 hover:text-slate-700 font-semibold px-8 py-6 text-base rounded-sm hover:bg-slate-50 active:scale-[0.98] transition-transform"
                data-testid="hero-cta-apply"
              >
                Apply for Strategy Call
              </Button>
            </div>
          </div>
          
          {/* Image */}
          <div className="relative hidden lg:block">
            <div className="relative rounded overflow-hidden shadow-xl">
              <img 
                src="https://images.pexels.com/photos/8811591/pexels-photo-8811591.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Roofing professional using tablet on job site"
                className="w-full h-auto object-cover aspect-[4/3]"
              />
              {/* Overlay Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-sm p-4 border border-slate-200">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse"></div>
                  <p className="font-medium text-slate-700 text-sm">
                    New lead from website form → AI responds in 8 seconds
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
